var _path, _rect, _path2, _rect2, _path3, _rect3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketDataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8L9 57",
    stroke: "#FFA300",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 39,
    width: 26,
    height: 10,
    rx: 2,
    transform: "rotate(-90 4 39)",
    fill: "#FFA300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1L25 53",
    stroke: "#FF0400",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 33,
    height: 10,
    rx: 2,
    transform: "rotate(-90 20 38)",
    fill: "#FF0400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 1L41 49",
    stroke: "#FF0400",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 25,
    width: 15,
    height: 10,
    rx: 2,
    transform: "rotate(-90 36 25)",
    fill: "#FF0400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_20745_839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 32.4581V58C57 59.1046 56.1046 60 55 60H17C15.8954 60 15 59.1046 15 58V47.4017C15 46.1469 16.1548 45.2116 17.4038 45.3318C35.6252 47.0859 37.653 26.3121 55.5509 30.579C56.4102 30.7839 57 31.5747 57 32.4581Z",
    fill: "url(#paint0_linear_20745_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 32.4581V58C57 59.1046 56.1046 60 55 60H17C15.8954 60 15 59.1046 15 58V47.4017C15 46.1469 16.1548 45.2116 17.4038 45.3318C35.6252 47.0859 37.653 26.3121 55.5509 30.579C56.4102 30.7839 57 31.5747 57 32.4581Z",
    fill: "url(#paint1_radial_20745_839)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32.4581V58C56.5 58.8284 55.8284 59.5 55 59.5H17C16.1716 59.5 15.5 58.8284 15.5 58V47.4017C15.5 46.4772 16.3644 45.734 17.3559 45.8295C26.4187 46.7019 31.5963 42.1138 36.4655 37.7989C36.6206 37.6615 36.7753 37.5243 36.9299 37.3876C39.4458 35.1628 41.893 33.0726 44.8039 31.7881C47.6929 30.5134 51.0637 30.0233 55.4349 31.0654C56.0559 31.2134 56.5 31.7923 56.5 32.4581Z",
    stroke: "url(#paint2_radial_20745_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32.4581V58C56.5 58.8284 55.8284 59.5 55 59.5H17C16.1716 59.5 15.5 58.8284 15.5 58V47.4017C15.5 46.4772 16.3644 45.734 17.3559 45.8295C26.4187 46.7019 31.5963 42.1138 36.4655 37.7989C36.6206 37.6615 36.7753 37.5243 36.9299 37.3876C39.4458 35.1628 41.893 33.0726 44.8039 31.7881C47.6929 30.5134 51.0637 30.0233 55.4349 31.0654C56.0559 31.2134 56.5 31.7923 56.5 32.4581Z",
    stroke: "url(#paint3_radial_20745_839)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32.4581V58C56.5 58.8284 55.8284 59.5 55 59.5H17C16.1716 59.5 15.5 58.8284 15.5 58V47.4017C15.5 46.4772 16.3644 45.734 17.3559 45.8295C26.4187 46.7019 31.5963 42.1138 36.4655 37.7989C36.6206 37.6615 36.7753 37.5243 36.9299 37.3876C39.4458 35.1628 41.893 33.0726 44.8039 31.7881C47.6929 30.5134 51.0637 30.0233 55.4349 31.0654C56.0559 31.2134 56.5 31.7923 56.5 32.4581Z",
    stroke: "url(#paint4_radial_20745_839)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0435 30.7169C53.1509 29.8151 49.1866 29.7472 45.3804 31.3242C41.8863 32.7719 39.0564 35.2495 36.3895 37.6039L36.2484 37.7285C33.5795 40.0851 31.0448 42.3231 27.9497 43.79C24.0388 45.6436 19.9245 45.6625 15.7933 44.9447C15.359 44.8692 14.9565 45.1998 14.9565 45.6406V47.0166C14.9565 47.4955 15.2959 47.9089 15.7682 47.9886C20.3131 48.7554 24.8689 48.544 29.1345 46.5224C32.5981 44.8808 35.4004 42.4053 37.9897 40.1179L38.2409 39.896C40.9545 37.5003 43.4452 35.353 46.4376 34.1132C49.9494 32.6581 53.5121 32.944 57.0435 33.8195V30.7169Z",
    fill: "#88A2B1",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8148 46.5974C14.3411 46.5189 14 46.1049 14 45.6247V44.3017C14 43.8619 14.4008 43.5315 14.8344 43.6056C18.9664 44.3114 23.0815 44.2931 26.9932 42.4714C30.0883 41.0301 32.6229 38.831 35.2918 36.5155L35.433 36.393C38.0998 34.0797 40.9298 31.6452 44.4238 30.2227C48.6195 28.5146 53.0073 28.7704 57.2794 29.9228C57.7078 30.0384 58 30.4307 58 30.8745V32.2565C58 32.7237 57.551 33.0595 57.1003 32.9366C53.2382 31.8838 49.329 31.3965 45.4811 32.9631C42.4887 34.1813 39.998 36.2913 37.2844 38.6452L37.0331 38.8633C34.4438 41.1108 31.6416 43.5433 28.178 45.1562C23.9133 47.1422 19.3587 47.3503 14.8148 46.5974Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_20745_839",
    x: 7,
    y: 22,
    width: 58,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20745_839",
    x1: 15,
    y1: 28.9674,
    x2: 29.8075,
    y2: 65.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20745_839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 28.9674) scale(42 34.0358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20745_839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4167 51.1852) rotate(4.96231) scale(16.3948 13.3379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20745_839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5833 35.1128) rotate(140.98) scale(6.75744 29.2227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20745_839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.25 35.5855) rotate(121.675) scale(16.6637 18.6166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketDataLogo);
export default __webpack_public_path__ + "static/media/marketDataLogo.f99ebd5f11d0164b54b4e63fb0d5be14.svg";
export { ForwardRef as ReactComponent };